<template>
  <header class="profile_header">
    <div v-if="isLoaded" class="profile_header_content" :style="`background-color: ${bgColor};`">
      <div class="profile_header_content_show container-fluid">
        <div class="row py-4">

          <div class="col-12 d-flex align-items-center t-white">
            <!-- picture -->
            <i class="t-xxxlr mr-3" :class="renderOrganisationCategoryIcon('research_group')"></i>
            <h1 class="t-white t-500 mr-4" v-html="researchGroup.highlights.name" />
            <span v-if="researchGroup.fte" class="t-white t-lr mr-4">{{ researchGroup.fte.name }} FTEs</span>

            <!-- edit research group -->
            <span v-if="$can.edit('research_group', researchGroup.rw_access)">
              <i class="fa fa-pencil t-sm pr-2"></i>
              <a class="t-white" href="#" @click.prevent="$events.$emit(`modal:research_group:open:create`, researchGroup)">Edit</a>
            </span>
          </div>
          <div class="col-12 d-flex align-items-baseline">
            <div class="t-400 t-lr t-white mr-4">
              Research Group
            </div>

            <!-- organisation -->
            <linked-list-collapsible
              v-if="!isEmpty(researchGroup.highlights) && !isEmpty(researchGroup.highlights.organisations)"
              :items="researchGroup.highlights.organisations"
              collapsible
              secondaryColor
              showFlags
              class="d-inline-block mr-4"
            />

            <ul v-if="!isEmpty(researchGroup.highlights.owners)" class="list-unstyled mb-0">
              <li class="list-inline clearfix d-inline-block mr-2 t-white" v-for="(owner, index) in researchGroup.highlights.owners" :key="owner.slug_values[0]">
                <i v-if="index === 0" class="fa fa-user t-sm pr-2"></i>
                <researcher-link :researcher="owner" :classObject="`t-white`"/><span v-if="index+1 < researchGroup.highlights.owners.length">,</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <sub-nav
        v-if="isLoaded"
        :name="`research_group_header_nav`"
        :text="true"
        :rw_access="researchGroup.rw_access"
        :counts="counts"
        :hasResearch="hasResearch"
        inverted
      />

    </div>
    <!-- render spinner if not loaded -->
    <spinner v-if="!isLoaded" :containerClass="`width--50px min-height--150px`" />
  </header>
</template>

<script>
import SubNav from '@/components/shared/nav/SubNav'
import ResearcherLink from '@/components/researcher/Link'
import Spinner from '@/components/shared/Spinner'
import LinkedListCollapsible from '@/components/shared/LinkedListCollapsible'

import { COLORS } from '@/assets/js/_data'

export default {
  name: 'researchGroupHeader',
  components: {
    SubNav,
    ResearcherLink,
    Spinner,
    LinkedListCollapsible
  },
  props: {
    isLoaded: {
      type: Boolean,
      required: true
    },
    researchGroup: {
      type: Object,
      required: true
    },
    hasResearch: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      bgColor: COLORS.research_group
    }
  },
  computed: {
    counts () {
      return {
        research_group_members: {
          total: this.researchGroup.researchers_count,
          color: 'secondary'
        },
        manage_invitations: {
          total: this.researchGroup.pending_invites_count,
          color: 'green'
        }
      }
    },
    researchGroupEdit () {
      return this.researchGroup.category === 'academic'
        ? 'create.research_group.academic'
        : 'create.research_group.company'
    }
  }
}
</script>
